/**
 * ชิ้นส่วนเล็ก ๆ ที่ใช้ซ้ำทั้งแอปตามภาษาดีไซน์ PixelPort
 *
 * หลักของธีมนี้คือ "อะไรที่เป็นข้อมูลให้คม อะไรที่เป็นกรอบให้มน" —
 * จุด/แถบ/ตราสัญลักษณ์เป็นสี่เหลี่ยมไม่มนมุม ส่วนการ์ดขอบมน 14px
 */
import type { ReactNode } from 'react';

/** โลโก้ 3×3 พิกเซล — ย่อ/ขยายด้วย `size` เท่านั้น สัดส่วนคงเดิมเสมอ */
export function PixelMark({ size = 26 }: { size?: number }) {
  const cells = [
    'bg-brand',
    'bg-up',
    'bg-brand',
    'bg-up',
    'bg-down',
    'bg-up',
    'bg-brand',
    'bg-up',
    'bg-brand',
  ];

  return (
    <div
      aria-hidden
      className="grid shrink-0 grid-cols-3 grid-rows-3 gap-[2px]"
      style={{ width: size, height: size }}
    >
      {cells.map((color, index) => (
        <div key={index} className={color} />
      ))}
    </div>
  );
}

/** หัวข้อของบล็อก — ตัวพิกเซลอังกฤษล้วน เพราะฟอนต์นี้ไม่มีตัวไทย */
export function SectionLabel({ children }: { children: ReactNode }) {
  return <div className="pixel-label">{children}</div>;
}

/** การ์ดมาตรฐาน — ใช้แทนการเขียน border/rounded/bg ซ้ำในทุกหน้า */
export function Card({ className = '', children }: { className?: string; children: ReactNode }) {
  return (
    <section className={`rounded-[14px] border border-line bg-surface ${className}`}>
      {children}
    </section>
  );
}

/**
 * สีประจำสินทรัพย์ — สุ่มจากชื่อแบบคงที่ ไม่ใช่จากลำดับในตาราง
 *
 * ผูกกับสัญลักษณ์เพื่อให้ BTC เป็นสีเดิมทุกหน้าและทุกครั้งที่เรียงใหม่
 * ถ้าผูกกับ index สีจะสลับกันเองเวลามูลค่าขยับ จำไม่ได้ว่าอันไหนคืออะไร
 */
const TINTS = [
  '#5b6bf5',
  '#4d8ee0',
  '#3fb0c6',
  '#2fd8a8',
  '#a08bf5',
  '#f7c453',
  '#f04c9a',
] as const;

export function tintFor(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return TINTS[hash % TINTS.length] as string;
}

/** ตราสองตัวอักษรหน้าชื่อสินทรัพย์ — ตัวหนังสือสีพื้นหน้าเข้ม อ่านออกบนทุกสีของ TINTS */
export function AssetTag({ symbol }: { symbol: string }) {
  return (
    <div
      aria-hidden
      className="grid size-7 shrink-0 place-items-center rounded-[5px] font-pixel text-[9px] text-ink"
      style={{ backgroundColor: tintFor(symbol) }}
    >
      {symbol.slice(0, 2).toUpperCase()}
    </div>
  );
}
